import React from "react";
import Breadcrumbs from "../../Breadcrumbs";
import Footer from "../../Footer";
import Header from "../../PagesHeader";
import Content from "./Content";
// import EmailSubscribe from "../../EmailSubscribe";
import BackToTop from "../../BackToTop";
import RequestModal from "../../RequestModal";
import SearchPopup from "../../SearchPopup";
// import BreadcrumbsData from "../../breadcrumbs.json";

const ServiceDouane = () => {
  return (
    <>
      <Header />
      <Breadcrumbs title="DOUANE & TRANSIT" description="" />
      <Content />
      {/* <EmailSubscribe /> */}
      <Footer />
      <SearchPopup />
      <RequestModal />
      <BackToTop />
    </>
  );
};
export default ServiceDouane;
